import React from 'react';
import Result from '../../components/AuditLogs/Result';

const AuditLogs = () => {
    return (
        <Result/>
    )
};

export default AuditLogs;